import styled from 'styled-components';

const accentBg = (props) => {
  if (props.accent === 'ucha') return props.theme.colors.orange;
  if (props.accent === 'eba') return props.theme.colors.blue;
  return 'transparent';
};

export const Container = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  padding: 15px;
  align-items: center;
  justify-content: space-between;
  background: ${accentBg};
  div {
    display: flex;
  }
`;

export const ParqueLabel = styled.h2`
  font-size: 16px;
  color: ${(props) =>
    props.accent ? props.theme.colors.white : props.theme.colors.darkerblue};
  font-weight: bold;
  margin-left: 10px;
`;

export const ParqueImage = styled.img`
  width: ${(props) => props.size};
  height: ${(props) => props.size};
  max-width: 200px;
  max-height: 200px;
`;

export const ErrorMessage = styled.div`
  display: flex;
  margin: auto;
  text-align: center;

  color: ${(props) => props.theme.colors.darkerblue};
  font-size: 18px;
  font-weight: 600;
`;

export const Tag = styled.div`
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 7px;
  margin: 0 10px;
  border-radius: 10px;
  background: ${(props) => props.color};
  transition: background-color 0.2s;
  text-transform: ${(props) => props.transform || 'uppercase'};
  color: ${(props) => props.theme.colors.white};
  font-weight: bold;
  font-size: 12px;
  @media (max-width: 1450px) {
    padding: 4px 10px;
  }
`;

export const StatusGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StatusDot = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${(props) => props.color};
  flex-shrink: 0;
`;

export const StatusLabel = styled.span`
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
  color: ${(props) =>
    props.accent ? props.theme.colors.white : props.theme.colors.darkerblue};
  letter-spacing: 0.3px;
`;
